<template>
  <div class="w-full h-full max-h-full max-w-full overflow-hidden">
    <RouterView></RouterView>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Future News',
    titleTemplate: '%s | Irish Aid 2022',
  },
};
</script>

<style></style>
